export default {
  paperFullWidth: {
    width: '100%',
  },
};
